import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email({ message: "Ongeldig e-mailadres" }),
  wachtwoord: z.string().min(1, { message: "Wachtwoord is verplicht" }),
});
export type LoginValues = z.infer<typeof loginSchema>;

export const tweeFASchema = z.object({
  code: z
    .string()
    .regex(/^\d{6}$/u, { message: "De code bestaat uit 6 cijfers" }),
});
export type TweeFAValues = z.infer<typeof tweeFASchema>;

export const wachtwoordWijzigenSchema = z
  .object({
    huidig_wachtwoord: z.string().min(1, { message: "Verplicht" }),
    nieuw_wachtwoord: z
      .string()
      .min(12, { message: "Minimaal 12 tekens" }),
    bevestig_wachtwoord: z.string().min(1, { message: "Verplicht" }),
  })
  .refine((v) => v.nieuw_wachtwoord === v.bevestig_wachtwoord, {
    path: ["bevestig_wachtwoord"],
    message: "De wachtwoorden komen niet overeen.",
  });
export type WachtwoordWijzigenValues = z.infer<typeof wachtwoordWijzigenSchema>;

export const klantWijzigenSchema = z.object({
  voornaam: z.string().max(128).optional().nullable(),
  achternaam: z.string().max(128).optional().nullable(),
  bedrijfsnaam: z.string().max(255).optional().nullable(),
  telefoon: z.string().max(32).optional().nullable(),
  mobiel: z.string().max(32).optional().nullable(),
  straat: z.string().max(255).optional().nullable(),
  huisnummer: z.string().max(32).optional().nullable(),
  postcode: z.string().max(16).optional().nullable(),
  woonplaats: z.string().max(128).optional().nullable(),
  taal: z.string().max(8).optional().nullable(),
  notities: z.string().optional().nullable(),
});
export type KlantWijzigenValues = z.infer<typeof klantWijzigenSchema>;

export const huisdierSchema = z.object({
  naam: z.string().min(1, { message: "Naam is verplicht" }).max(128),
  diersoort: z.enum([
    "hond",
    "kat",
    "knaagdier",
    "vogel",
    "vis",
    "reptiel",
    "anders",
  ]),
  ras: z.string().max(128).optional().or(z.literal("")),
  // Drietoestand-selects: "" = onbekend (niet meesturen).
  geslacht: z.enum(["mannelijk", "vrouwelijk", ""]).optional(),
  castratie: z.enum(["ja", "nee", ""]).optional(),
  geboortedatum: z.string().optional().or(z.literal("")),
  // Alternatief voor geboortedatum: wordt een geschatte geboortedatum
  // (geboortedatum is de bronwaarde, fase 2a).
  leeftijd_jaren: z.string().optional().or(z.literal("")),
  gewicht_kg: z.string().optional().or(z.literal("")),
  voer_voorkeur: z.string().optional().or(z.literal("")),
  allergieen: z.string().optional().or(z.literal("")),
  bijzonderheden: z.string().optional().or(z.literal("")),
  leefomgeving: z.enum(["binnen", "buiten", ""]).optional(),
  veterinair_probleem: z.string().optional().or(z.literal("")),
  veterinair_probleem_actueel: z.enum(["is", "was", ""]).optional(),
  veterinair_dieetlijn: z.string().max(128).optional().or(z.literal("")),
  veterinair_toelichting: z.string().optional().or(z.literal("")),
  is_overleden: z.boolean().optional(),
  overleden_op: z.string().optional().or(z.literal("")),
});
export type HuisdierValues = z.infer<typeof huisdierSchema>;

export const gebruikerAanmakenSchema = z.object({
  email: z.string().email({ message: "Ongeldig e-mailadres" }),
  naam: z.string().min(1, { message: "Naam is verplicht" }).max(255),
  rol: z.enum(["admin", "medewerker", "alleen_lezen", "toets"]),
});
export type GebruikerAanmakenValues = z.infer<typeof gebruikerAanmakenSchema>;

export const anonimiseerSchema = z.object({
  reden: z.string().min(5, { message: "Geef een reden op (min 5 tekens)." }),
  bevestigd: z.boolean().refine((v) => v === true, {
    message: "Bevestiging is vereist.",
  }),
});
export type AnonimiseerValues = z.infer<typeof anonimiseerSchema>;
